var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnail-navigation"},_vm._l((_vm.gallery),function(image,index){return _c('pdp-thumbnail-image',{key:index,attrs:{"image":image,"index":index,"page":_vm.page},on:{"updateCarousel":_vm.updateCarousel}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }